import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import axiosIntance from '../../../helper/axios';
import { useHistory,useParams } from "react-router-dom";
import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import {baseUrl} from '../../../config';
import DatePicker from "react-datepicker";
import './css/chargebackreport.css';
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';
import {clickColor,inArray} from './../../../library/util';
import {formatNumberWithToFixed} from '../../../library/util';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import AddIcon from '@mui/icons-material/Add';
import objAdvancedFilter from '../../../library/advancedFilterLibFn';


const colourStyles = {
  menuList: styles => ({
      ...styles,
      background: 'white'
  }),
  option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      background: isFocused
          ? 'lightblue'
          : isSelected
              ? '#2a7bc0'
              : undefined,
      zIndex: 1
  }),
  menu: base => ({
      ...base,
      zIndex: 100
  })
  }
  const style_advanced = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };



const AddIconClasses={ color: '#337ab7',fontSize:'30px',marginLeft:'128px',marginTop:"-15px",cursor: 'pointer' };

const styleCloseIcon={
  margin:'-27px'
}

const animatedComponents = makeAnimated();





function ChargebackRefundReturn() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23,59,0,0));
    const [productCategory,setProductCategory]=useState('');
    const [productCategoryArray,setProductCategoryArray] = useState([]);
    const [AFFID,setAFFID]=useState('');
    const [AFFIDArray,setAFFIDArray]=useState([]);
    const [C1,setC1]=useState('');
    const [C1Array,setC1Array]=useState([]);
    const { type } = useParams()
    const reportName=`Chargeback/Refund Reports - by Date of Return by - ${type}`

    // console.log('heyeyye')

    let columnsData=[
      { title: "Orders.Count", field: "orders_count" },
      { title: "Orders.Sum.Total", field: "ordersumtotal" },
      { title: "Cbs.Count", field: "cbscount" },
      { title: "Cbs.Sum.Total", field: "cbsumtotal" },
      { title: "Refunds.Count", field: "refundcount" },
      { title: "Refunds.Sum.Total", field: "refundsumtotal" },
      { title: "Cb.Count.Percent", field: "cbscountp" },
      { title: "Cb.Volume.Percent", field: "cbvolumep" },
      { title: "Refund.Count.Percent", field: "refundcountp" },
      { title: "Refund.Volume.Percent", field: "refundvolumep" },
    ]
    if(type!=undefined && type.toLowerCase()=='productcategory'){
    columnsData.unshift({ title: "Product.Category", field: "product_category" })
    }else if(type!=undefined && type.toLowerCase()=='affid'){
    columnsData.unshift({ title: "AFFID", field: "affid" })
    columnsData.unshift({ title: "Product.Category", field: "product_category" })
    }else if(type!=undefined && type.toLowerCase()=='c1'){
    columnsData.unshift({ title: "C1", field: "c1" })
    columnsData.unshift({ title: "AFFID", field: "affid" })
    columnsData.unshift({ title: "Product.Category", field: "product_category" })
    }
    

    const [selectedrowList,setSelectedRowList]=useState([]);

     /************* Advanced Filter ***********/
     const [group,setgroup]=useState('');
     const [groupT,setgroupT]=useState('');
     const [open, setOpen] = React.useState(false);
     const handleOpen = () => setOpen(true);
     const handleClose = () => setOpen(false);
     const selectInputRef = useRef();
     const selectInputRefInputFilter=useRef();
     const [filterValueT,setFilterValueT]=useState('')
     const [filterArrayT,setFilterArrayT]=useState([]);
     const [selectLabelHeader,setSelectLabelHeader]=useState([]);
     
 
  
     const loadFilterLabel=(inputValue)=>
     {
       let tempCategory=selectLabelHeader;
       return new Promise((resolve) => {
         resolve(tempCategory.filter((i) =>
               i.label.toLowerCase().includes(inputValue.toLowerCase())
          ))
       });
     }

   const handleChangeFilterT=(e)=>{
     if(e.target.value!=undefined){
       setFilterValueT(e.target.value);
     }
   }
 
 
   const addFilterT=()=>{
     if(groupT!='' && filterValueT!=''){
       let tempObj={field:groupT,value:filterValueT};  
         filterArrayT.push(tempObj);
         setFilterArrayT(filterArrayT);
         setFilterValueT('')
     }
   }
 
  
 
 
 
   const deleteAdvancedFilterTFn = (item,index) =>{
    const arr = filterArrayT.filter((item,j) => j!=index);
    console.log(arr)
    setFilterArrayT(arr);
   }
 const handleChangeT=( target )=> {
   if(target!=undefined){
     setgroupT(target.value);
   }
 }


 const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
    
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }

      
   
    if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      history.push('/');
    }
    checkUserTypeFn(history);  

    function checkUserTypeFn(history){
      const userdata=JSON.parse(localStorage.getItem('userdata'));
      const usertype=userdata.type;
      console.log('in check usertype fn');
      console.log(usertype)
      if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='user' && usertype!='owneradmin'){
        history.push('/');
     }
    }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      setSelectLabelHeader(objAdvancedFilter.getFilterColumns('transactions'))
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])
    
    const ResetFilter = () => {
      setMessage('')
      setEndDate(new Date(Date.now()))
      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
      setProductCategory('');
      setAFFID('')
      setReportData([]);
      setProductCategoryArray([]);
      setAFFIDArray([]);
      setC1('')
      setC1Array([])
      //setProductCategoryStr('');
    }

    
   
  const fetchApi = () =>{
    let filterStringT='';
    filterArrayT.forEach((i,j)=>{
      filterStringT+=`t.${i.field}=${i.value}*`
    })
    if(startDate==null){
      setMessage('Start Date must not be blank')
      return false;
    }if(endDate==null){
      setMessage('End Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    let productCategoryStr=productCategoryArray.join(',');
    console.log(productCategoryStr);
    let affidStr=AFFIDArray.join(',');
    console.log(affidStr)
    let C1Str=C1Array.join(',');
    console.log(C1Str);
    axiosIntance.get(baseUrl+'/reports/chargebackReturn?type='+type+'&startdate='+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss')+"&productCategory="+productCategoryStr+"&AFFID="+affidStr+"&C1="+C1Str+"&filterStringT="+filterStringT, {}).then(response => {
  
        if (response.data.result.length > 0) {
          console.log('data we have')
          response.data.result.forEach((i,j)=>{
            console.log(i);
            i.refundvolumep=roundToTwo(i.refundvolumep*100)+"%";
            i.refundcountp=roundToTwo(i.refundcountp*100)+"%";
            i.cbvolumep=roundToTwo(i.cbvolumep*100)+"%";
            i.cbscountp=roundToTwo(i.cbscountp*100)+"%";


            i.ordersumtotal="$"+formatNumberWithToFixed(i.ordersumtotal).toLocaleString();
            i.cbsumtotal="$"+formatNumberWithToFixed(i.cbsumtotal).toLocaleString();
            i.refundsumtotal="$"+formatNumberWithToFixed(i.refundsumtotal).toLocaleString();
          });
          setReportData(response.data.result);
          console.log(response.data.result)
          setLoader(false)
          //setSuccessMsg('Data')
        } else {
          setLoader(false)
          setReportData([]);
          //setMessage('No data');
          console.log(45)
         // history.push('/home');
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{
    let filterStringT='';
    filterArrayT.forEach((i,j)=>{
      filterStringT+=`T.${i.field}=${i.value}*`
    })
    let productCategoryStr=productCategoryArray.join(',');
    console.log(productCategoryStr);
    let affidStr=AFFIDArray.join(',');
    console.log(affidStr)
    let C1Str=C1Array.join(',');
    console.log(C1Str);
    const token = window.localStorage.getItem('token');
    window.location.href=baseUrl+'/reports/chargebackReturn/download?type='+type+'&startdate='+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss')+"&productCategory="+productCategoryStr+"&AFFID="+affidStr+"&C1="+C1Str+"&filterStringT="+filterStringT+"&token="+token;
  }

  const FilterSet=() =>{
    console.log('Filter resete');
    console.log(productCategory);
    if(productCategory!=''){
      if(inArrayForString(productCategory,productCategoryArray)==false){ 
      setProductCategoryArray(oldArray => [...oldArray,productCategory] );
      setProductCategory('');
      }
    }
    console.log(AFFID);
    if(AFFID!=''){
      if(inArrayForString(AFFID,AFFIDArray)==false){ 
      setAFFIDArray(oldArray => [...oldArray,AFFID] );
      setAFFID('');
      }
    }
    if(C1!=''){
      if(inArrayForString(C1,C1Array)==false){ 
      setC1Array(oldArray => [...oldArray,C1] );
      setC1('');
      }
    }
      //setProductCategoryStr();
    }
   
  

  const deleteProductCategoryFn = (item,index) =>{
    console.log(item);
    removeItemOnce(productCategoryArray,item);
    console.log(productCategoryArray);

    let temp = productCategoryArray.filter((category) => category !== item);
    console.log(temp);
    setProductCategoryArray(temp);
  }
  const deleteAFFIDFn = (item,index) =>{
    console.log(item);
    removeItemOnce(AFFIDArray,item);
    console.log(AFFIDArray);

    let temp = AFFIDArray.filter((category) => category !== item);
    console.log(temp);
    setAFFIDArray(temp);
  }
  const deleteC1Fn = (item,index) =>{
    console.log(item);
    removeItemOnce(C1Array,item);
    console.log(C1Array);

    let temp = C1Array.filter((category) => category !== item);
    console.log(temp);
    setC1Array(temp);
  }
  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
    <section id="content-wrapper">

    <div classname="advancedFilterSection">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
     <Box sx={style_advanced}>


<label>Transaction Header</label>
<label className='filterValueStyle'>Filter Values</label> 
<div class="input-bar">

<div className="input-bar-item width100">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChangeT(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.label}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabel}        
/>
</div>

<>

&nbsp;&nbsp;&nbsp;
<div className="input-bar-item width100">
  <input type='text'
     ref={selectInputRefInputFilter}
     className='width140x filterValue'
     placeholder="Value"
     onChange={e => handleChangeFilterT(e)} 
     />
  <AddIcon style={AddIconClasses} onClick={addFilterT}/>
</div>
</>

 
<div className="input-bar-item width100">
<div className="input-bar-item closeModel closeIconCommon"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>
</div>

</div>



<div className="input-bar-item width100">
<div className="FilterSection">

    {filterArrayT.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}


</div>

</div>




     </Box>
     </Modal>
</div>

    <label>Start Date</label>
    
    <label className='endDateStyle'>End Date</label>
    <label className='productCategoryStyle'>Product Category</label>
    <label className='affidStyle'>AFFID</label>
    <label className='c1Style'>C1</label>
    
    <div className="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Start Date'
      />

    </div>
    
    &nbsp;&nbsp;&nbsp;
 
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      selected={endDate}
      className='width140x'
      onChange={(date) => setEndDate(date)}
      placeholder='End Date'
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;
    <div className="input-bar-item width100">
    
    <input 
    type="text" 
     name='productCategory'
     className='width140x'
     value={productCategory}
     placeholder="Product Category"
     onChange={e => setProductCategory(e.target.value)} 
     
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;
    <div className="input-bar-item">
    
    <input type='text'
     name='affid'
     value={AFFID}
     className='width50x'
     placeholder="AFFID"
     onChange={e => setAFFID(e.target.value)}
     />
      
    </div>

    &nbsp;&nbsp;&nbsp;
    <div className="input-bar-item">
    
    <input type='text'
     name='C1'
     value={C1}
     className='width50x'
     placeholder="C1"
     onChange={e => setC1(e.target.value)}
     />
      
    </div>

    <div className="input-bar-item">
    <button type="button"  onClick={FilterSet} className="btn btn-primary">Filter</button>
   
    </div>

    <div className="input-bar-item">
    <button type="button"  onClick={handleOpen}  className="btn btn-primary">Advanced Filter</button>
   
    </div>

    <div className="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div className='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}
      <div className='downloadReportBtn'>
        {
          
          <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
  </div>


  <div className="FilterSection">
  
  {productCategoryArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">Prodcat = {item}{ }</span>
       <span  onClick={(event) => deleteProductCategoryFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}

{AFFIDArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">AFFID = {item}{ }</span>
       <span  onClick={(event) => deleteAFFIDFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}

{C1Array.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">C1 = {item}{ }</span>
       <span  onClick={(event) => deleteC1Fn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}

{filterArrayT.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}
    
  </div>

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
          <MaterialTable
          // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

          onRowClick={((evt, selectedRow) => 
            setRowBackground(selectedRow)
            )}
            columns={columnsData}
            data={
                reportData
            }
             title={reportName}
          
            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              pageSize:10,
              loadingType: 'overlay',
              paging: false,
              exportButton: true,
              maxBodyHeight: '500px',
              headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              })
              }}
              // components={{
              //   OverlayLoading: props => (<div>Heye</div>)
              // }}
          />
        }
        </section>
       
      </div>

    )
}

function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
  if (haystack[i].toLowerCase() == needle.toLowerCase())
   return true;
  }
  return false;
 }

export default ChargebackRefundReturn
